// @flow

import React from 'react';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {Button, Typography, makeStyles} from '@material-ui/core';
import {Link} from 'react-router-dom';

import previewImage from '../../../../assets/img/home-pages/home-page-preview.webp';

type Props = {
  open: boolean,
  handleClose: () => void,
};

const useStyles = makeStyles(theme => ({
  modalPreview: {
    '& .MuiPaper-root': {
      height: '100%',
      background: '#18003D',
      maxHeight: 'calc(100% - 32px)',
      margin: theme.spacing(4, 4, 0, 4),
      overflow: 'auto',
    },
  },
  preview: {
    maxWidth: 700,
    // maxHeight: 750,
    padding: theme.spacing(7, 4),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  title: {
    fontSize: 22,
    fontWeight: 600,
    color: 'white',
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 16,
    color: 'white',
    margin: theme.spacing(2, 0),
    textAlign: 'center',
  },
  img: {
    width: '100%',
    height: '100%',
  },
  buttonPro: {
    padding: theme.spacing(1, 4),
    background: 'linear-gradient(to right, #FFC83B, #7B39FF)',
    color: 'white',
    textTransform: 'none',
    borderRadius: 20,
  },
}));

export default function HomePagePreview(props: Props) {
  const {open, handleClose} = props;
  const classes = useStyles();
  return (
    <CustomModal
      open={open}
      handleCloseModal={handleClose}
      className={classes.modalPreview}
    >
      <div className={classes.preview}>
        <Typography className={classes.title} gutterBottom>
          Así se vería tu tienda con
          <br /> TiendaDA pro+
        </Typography>

        <Typography className={classes.subtitle}>
          Actualiza tu plan para tener más
          <br /> control de tu personalización.
        </Typography>

        <Button className={classes.buttonPro} component={Link} to="/tiers-list">
          Activar PRO+
        </Button>

        <div style={{marginTop: '2rem'}}>
          <img className={classes.img} src={previewImage} alt="preview img" />
        </div>
      </div>
    </CustomModal>
  );
}
